import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})

export class LogoutComponent implements OnInit {

  loginForm : FormGroup;  
  returnUrl: string;
  errors: string[];
  constructor(    
    private router: Router,
    private route: ActivatedRoute,    
  ) { }

  ngOnInit() {    
    //this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    localStorage.removeItem('userconfig');
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');          
    localStorage.removeItem("username");
    this.router.navigate(['/auth/newlogin']);
  }
}